import React from 'react';
import PrivacyPolicy from './components/privacyPolicy';
import Header from '../homepage/components/header';
import Footer from '../homepage/components/footer';

function PrivacyPolicyPage() {
  return (
    <div>
      <Header />
      <PrivacyPolicy />
      <Footer />
    </div>
  );
}

export default PrivacyPolicyPage;
